import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid player-groups" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }

import TableLite from "vue3-table-lite/ts";
import { playerGroupsModule } from "@/store/modules/player-groups.module";
import {
  computed,
  reactive,
  onBeforeMount,
  onBeforeUnmount,
  onDeactivated,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  name: 'player-groups-page',
  setup(__props) {

const load = async () => {
  await playerGroupsModule.load();
};

onDeactivated(() => playerGroupsModule.reset());

onBeforeMount(load);

const groups = computed(() =>
  playerGroupsModule.data != null ? playerGroupsModule.data : []
);

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: "id",
      field: "Id",
      width: "5%"
    },
    {
      label: "Name",
      field: "name",
      width: "95%"
    },
  ],
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(TableLite), {
          "is-slot-mode": true,
          columns: table.columns,
          "is-static-mode": true,
          "is-re-search": true,
          rows: _unref(groups),
          total: _unref(groups)?.length,
          pageOptions: [],
          messages: {
              pagingInfo: '',
              pageSizeChangeLabel: '',
              gotoPageLabel: '',
              noDataAvailable: 'No data',
            }
        }, {
          id: _withCtx((data) => [
            _createTextVNode(_toDisplayString(data.value?.Id), 1)
          ]),
          name: _withCtx((data) => [
            _createVNode(_component_router_link, {
              to: {
                name: 'PlayerGroupInnerPage',
                params: { id: data.value.id },
              }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.value?.Name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["columns", "rows", "total"])
      ])
    ])
  ]))
}
}

})